import { createHooks } from 'hookable'

const SlipPayoutHooksManager = createHooks<{
  BeforeSlipPayout: () => Promise<void>
}>()

export { SlipPayoutHooksManager }
